<template>
  <div>
    <a-table bordered
            :loading="loading"
            :columns="columns"
            :data-source="recordList"
            :pagination="pagination"
            :scroll="{ x: 1100 }"
            @change="handleTableChange"
    >
    </a-table>
  </div>
</template>

<script>
import { findRoleAuthorizeRecordPage } from "api/roleAuthorizeRecord"

export default {
  name: 'RoleAuthorizeRecordTable',
  data() {
    return {
      columns: [
        {key: 'id', title: 'ID', align: 'center', dataIndex: 'id', width: 80},
        {key: 'userName', title: '被授权用户账号', align: 'center', dataIndex: 'userName', ellipsis: true, width: 160},
        {key: 'userNickname', title: '被授权用户昵称', align: 'center', dataIndex: 'userNickname', ellipsis: true, width: 160},
        {key: 'roleNames', title: '授权角色', align: 'center', dataIndex: 'roleNames', ellipsis: true},
        {key: 'authorizeTime', title: '授权时间', align: 'center', dataIndex: 'authorizeTime', ellipsis: true, width: 180},
        {key: 'operatorName', title: '操作人账号', align: 'center', dataIndex: 'operatorName', ellipsis: true, width: 140},
        {key: 'operatorNickname', title: '操作人昵称', align: 'center', dataIndex: 'operatorNickname', ellipsis: true, width: 140},
        {key: 'remark', title: '备注', align: 'center', dataIndex: 'remark', ellipsis: true}
      ],
      pagination: {
        defaultPageSize: 10,
        showQuickJumper: true,
        total: 0,
        showTotal: total => `共 ${this.pagination.total} 条数据`,
        onShowSizeChange: (current, pageSize) => this.pageSize = pageSize
      },
      loading: false,
      pageIndex: 0,
      pageSize: 10,
      recordList: [],
      condition: {
        userName: '',
        operatorName: '',
        startTime: '',
        endTime: ''
      }
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      const payload = {
        page: this.pageIndex + 1,
        pageSize: this.pageSize,
        ...this.condition
      }
      this.loading = true
      findRoleAuthorizeRecordPage(payload).then(res => {
        this.loading = false
        if (res && res.data) {
          this.recordList = res.data.rows || []
          this.pagination.total = res.data.total || 0
          this.pagination.current = this.pageIndex + 1
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleTableChange(pagination) {
      this.pageIndex = (pagination.current || 1) - 1
      this.pageSize = pagination.pageSize || this.pageSize
      this.fetchData()
    },
    onSearch(condition) {
      this.pageIndex = 0
      this.condition = Object.assign({
        userName: '',
        operatorName: '',
        startTime: '',
        endTime: ''
      }, condition || {})
      this.pagination.current = 1
      this.fetchData()
    }
  }
}
</script>

<style lang='scss' scoped>
::v-deep .ant-table {
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}
::v-deep .ant-table-thead > tr > th {
  background: #33CCE0 !important;
  color: #fff !important;
  font-weight: 600;
  border-color: #7fddec !important;
}
::v-deep .ant-table-tbody > tr > td {
  background: #fff !important;
}
::v-deep .ant-table-tbody > tr:hover > td {
  background: #e6f9fc !important;
}
::v-deep .ant-table-bordered .ant-table-thead > tr > th,
::v-deep .ant-table-bordered .ant-table-tbody > tr > td {
  border-color: #b3eaf3 !important;
}
</style>
